module.exports = __webpack_public_path__ + "img/stamp_h_none@2x.5003329f.png";